import React, {useState, useContext} from "react";
import MessageDialog from "../components/MessageDialog";
import axios from "axios";
import GlobalContext from "../utils/GlobalContext";
import { Form, Input, Button, Typography } from 'antd';

const { Title } = Typography;

const ChangePassword = ({ changeUser, onChangedPass }) => {

  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const globals = useContext(GlobalContext);

  const showErrorDialog = () => {
    setErrorDialogVisible(true);
  };

  const handleOkErrorDialog = () => {
    setErrorDialogVisible(false);
  };

  const handleChangedPassword = async (values) => {
    if (values.password !== values.repassword) {
      setErrorMessage("Las contraseñas deben ser iguales");
      showErrorDialog()
      return;
    }
    try{
      const res = await axios.put(`${globals.SERVICE_API_AUTH}/v1/cambio-password`,
        { 
          email: changeUser.email, 
          password: changeUser.password,
          newPassword: values.password
        },
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      const result = res.data;
      if (result.status === 0) {
        onChangedPass()
      } else {
        setErrorMessage(result?.msg);
        showErrorDialog()
        return;
      }
    }
    catch(err) {
      console.log(err.response.data);
      if (err?.response?.data?.msg === undefined) {
        setErrorMessage("Cambiar contraseña falló");
      }
      else {
        setErrorMessage(err?.response?.data?.msg);
      }
      showErrorDialog()
      return;
    }

  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <img src="/logo.png" height="200px" alt="" />
      <br />
      <Title level={5}>Debes cambiar tu contraseña</Title>
      <div
        style={{
          width: '370px',
          padding: '20px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px',
        }}
      >
        <Form
          name="loginForm"
          onFinish={handleChangedPassword}
        >
          <Form.Item
            label="Nueva contraseña"
            name="password"
            rules={[
              {
                required: true,
                message: 'Por favor ingrese su nueva contraseña',
              },
              { min: 6, message: "Contraseña debe tener al menos 6 caracteres" },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Repite nueva contraseña"
            name="repassword"
            rules={[
              { required: true, message: "Por favor repite tu nueva contraseña" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Las contraseñas no coinciden")
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Cambiar contraseña
            </Button>
          </Form.Item>
        </Form>
      </div>
      <MessageDialog
        visible={errorDialogVisible}
        title="Cambio de contraseña fallido"
        message= {`${errorMessage}, por favor intenta de nuevo.`}
        onOk={handleOkErrorDialog}
        onCancel={handleOkErrorDialog}
        confirm={false}
      />
    </div>
  );
};

export default ChangePassword;
